import SocialSecurityNumberField from './SocialSecurityNumberField';

export default SocialSecurityNumberField;
